if (!customElements.get('cart-shipping-estimate')) {
  // Rates come live from Shopify using a separate temporary cart, so the visitor's own cart
  // and checkout address stay untouched. These countries need a province to return a rate.
  const SAMPLE_PROVINCES = {
    AU: 'NSW',
    CA: 'ON',
    ES: 'M',
    IE: 'D',
    IT: 'RM',
    KR: 'KR-11',
    NZ: 'AUK',
    PT: 'PT-11',
    RO: 'B',
    US: 'NY',
  };
  const RATES_QUERY = `mutation ($input: CartInput!, $country: CountryCode) @inContext(country: $country) {
    cartCreate(input: $input) {
      cart {
        deliveryGroups(first: 5) {
          nodes {
            deliveryOptions {
              estimatedCost {
                amount
              }
            }
          }
        }
      }
    }
  }`;
  const STORAGE_KEY = 'shipping-estimate-country';

  const savedCountry = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  };

  customElements.define(
    'cart-shipping-estimate',
    class CartShippingEstimate extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.price = this.querySelector('.shipping-estimate__price');
        this.fillCountries();
        this.select.addEventListener('change', () => {
          try {
            sessionStorage.setItem(STORAGE_KEY, this.select.value);
          } catch (e) {}
          this.update();
        });
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.update());
        this.update();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      fillCountries() {
        const data = document.getElementById('ShippingEstimateCountries');
        const countries = data ? JSON.parse(data.textContent) : [];
        const current = savedCountry() || (window.Shopify && Shopify.country);
        countries.forEach(([code, name]) => {
          const option = new Option(name, code);
          option.selected = code === current;
          this.select.add(option);
        });
      }

      fetchRates(items) {
        const countryCode = this.select.value;
        const deliveryAddress = { countryCode };
        if (SAMPLE_PROVINCES[countryCode]) deliveryAddress.provinceCode = SAMPLE_PROVINCES[countryCode];
        const input = {
          lines: items.map((item) => ({
            merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
            quantity: item.quantity,
          })),
          delivery: { addresses: [{ address: { deliveryAddress }, selected: true }] },
        };
        return fetch('/api/2026-10/graphql.json', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: RATES_QUERY,
            variables: { input, country: window.Shopify && Shopify.country },
          }),
        }).then((response) => (response.ok ? response.json() : Promise.reject()));
      }

      formatPrice(amount) {
        const zero = this.dataset.moneyZero;
        const separator = zero.includes(',') ? ',' : '.';
        return zero.replace(/0[.,]00/, amount.toFixed(2).replace('.', separator));
      }

      update() {
        const request = (this.request = {});
        this.price.textContent = '…';
        fetch(`${routes.cart_url}.js`)
          .then((response) => (response.ok ? response.json() : Promise.reject()))
          .then((cart) => this.fetchRates(cart.items))
          .then(({ data }) => {
            if (request !== this.request) return;
            const rates = data.cartCreate.cart.deliveryGroups.nodes.flatMap((group) =>
              group.deliveryOptions.map((option) => parseFloat(option.estimatedCost.amount))
            );
            if (!rates.length) throw new Error('No rates');
            this.price.textContent = this.formatPrice(Math.min(...rates));
          })
          .catch(() => {
            if (request === this.request) this.price.textContent = this.dataset.unavailable;
          });
      }
    }
  );
}
